import type { Profile } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";

export const isTeensAndKidsProgram = (profile: Profile) => {
  return profile?.group_type === "teens_kids_program";
};

const AGE_CONSIDERED_ADULT = 18;

export const isAdult = (dob: Profile["dob"]) => {
  const today = dayjs();
  const timeAgo = today.subtract(AGE_CONSIDERED_ADULT, "year");

  return dayjs(dob).isBefore(timeAgo) || dayjs(dob).isSame(timeAgo);
};
